import { toast } from "sonner";
import { api, formatApiError } from "@/lib/apiClient";

const RZP_SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

function loadScript(src) {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const s = document.createElement("script");
    s.src = src; s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

/**
 * Trigger Razorpay Checkout for the given invoice and call onPaid({ invoice }) on success.
 */
export async function payInvoiceWithRazorpay(invoice, onPaid) {
  if (!invoice?.invoice_number) {
    toast.error("No invoice selected");
    return;
  }
  const ok = await loadScript(RZP_SCRIPT);
  if (!ok) {
    toast.error("Could not load Razorpay. Check your connection.");
    return;
  }
  let order;
  try {
    const { data } = await api.post("/payments/razorpay/order", { invoice_number: invoice.invoice_number });
    order = data;
  } catch (e) { toast.error(formatApiError(e)); return; }

  if (!order.key_id) {
    toast.error("Razorpay is not configured. Please contact support.");
    return;
  }

  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    name: "Pop Panda",
    description: `Invoice ${invoice.invoice_number}`,
    order_id: order.order_id,
    prefill: {
      name: order.customer?.name || invoice.customer_name || "",
      email: order.customer?.email || invoice.customer_email || "",
      contact: order.customer?.contact || invoice.customer_phone || "",
    },
    theme: { color: "#FFC93C" },
    notes: order.notes,
    handler: async (resp) => {
      try {
        const { data } = await api.post("/payments/razorpay/verify", {
          invoice_number: invoice.invoice_number,
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        toast.success("Payment received!");
        onPaid?.(data);
      } catch (e) {
        toast.error(formatApiError(e) || "Verification failed. Contact support with your payment id.");
      }
    },
    modal: {
      ondismiss: () => toast.info("Payment cancelled."),
    },
  });
  rzp.on?.("payment.failed", (r) => toast.error(r?.error?.description || "Payment failed."));
  rzp.open();
}
